export default {"src":"/_next/static/media/NetworkDAO.ce01c947.gif","height":500,"width":500,"blurWidth":0,"blurHeight":0};